const pageData = {
  aboutUs: {
    aboutUsMenu: [
      {
        id: 1,
        name: 'about_us',
        url: '/about-us'
      },
      {
        id: 2,
        name: 'guest_service',
        url: '/about-us/guest-service'
      },
      {
        id: 3,
        name: 'mall_map',
        url: '/about-us/mall-map'
      },
      // {
      //   name: 'tbilisi_mall_taxi',
      //   url: '/about-us/tbilisi-mall-taxi'
      // },
      {
        id: 4,
        name: 'gift_card',
        url: '/about-us/gift-card'
      },
      {
        id: 7,
        name: 'magazine',
        url: '/about-us/magazine'
      },
      {
        id: 5,
        name: 'marketing',
        url: '/about-us/marketing'
      },
      {
        id: 6,
        name: 'leasing',
        url: '/about-us/leasing'
      }
    ]
  }
}

export default pageData
